import { css } from "styled-components";

import { info } from "./BentoBox.info";
import { Variant } from "./BentoBox.types";

export const getVariant = (variant: Variant) => {
  if (variant === "small") {
    return css`
      --bento-box-height: ${info.heights.small.default}px;

      ${props => props.theme.breakpointsV2.smallTablet} {
        --bento-box-height: auto;
      }
    `;
  }

  if (variant === "medium") {
    return css`
      --bento-box-height: ${info.heights.medium.default}px;

      ${props => props.theme.breakpointsV2.smallTablet} {
        --bento-box-height: ${info.heights.medium.smallTablet}px;
      }

      ${props => props.theme.breakpointsV2.smallDesktop} {
        --bento-box-height: ${info.heights.medium.smallDesktop}px;
      }
    `;
  }

  return css`
    --bento-box-height: ${info.heights.large.default}px;

    ${props => props.theme.breakpointsV2.smallTablet} {
      --bento-box-height: ${info.heights.large.smallTablet}px;
    }

    ${props => props.theme.breakpointsV2.smallDesktop} {
      --bento-box-height: ${info.heights.large.smallDesktop}px;
    }
  `;
};
